// app/javascript/controllers/wizard_step_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton", "errors"]
  static values = {
    submitUrl: String
  }

  connect() {
  }

  async submit(event) {
    event.preventDefault()

    const form = event.target;
    const submitButton = form.querySelector('[type="submit"]')
    let originalContent
    const isInput = submitButton.tagName === 'INPUT'

    if (isInput) {
      originalContent = submitButton.value
      submitButton.value = "Processing..."
    } else {
      originalContent = submitButton.innerHTML
      submitButton.innerHTML = this.spinnerHTML
    }

    const formData = new FormData(form)

    formData.set('draft', 'true')

    // Disable form and show spinner
    this.disableForm(form, submitButton)
    this.clearErrors()

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      })

      if (response.ok) {
      } else {
        // Handle validation errors
        const data = await response.json()
        this.showErrors(data.errors)
      }
    } catch (error) {
      this.showErrors(["An unexpected error occurred. Please try again."])
    } finally {
      if (isInput) {
        submitButton.value = originalContent
      } else {
        submitButton.innerHTML = originalContent
      }
      submitButton.disabled = false
      this.enableForm(form, submitButton)
      this.submitFormToSave(form)
    }
  }

  submitFormToSave(form) {
    // Remove the Stimulus action to prevent infinite loop
    form.removeAttribute('data-action')

    form.requestSubmit()
  }

  disableForm(form, submitButton) {
    submitButton.disabled = true
    form.querySelectorAll("input, select, textarea").forEach(el => {
      el.disabled = true
    })
  }

  enableForm(form, submitButton) {
    submitButton.disabled = false
    form.querySelectorAll("input, select, textarea").forEach(el => {
      el.disabled = false
    })
  }

  showErrors(errors) {
    if (this.hasErrorsTarget) {
      this.errorsTarget.innerHTML = errors.map(error =>
        `<p class="text-red-600">${error}</p>`
      ).join("")
      this.errorsTarget.classList.remove("hidden")
    }
  }

  clearErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.innerHTML = ""
      this.errorsTarget.classList.add("hidden")
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }

  get spinnerHTML() {
    return `
    <div class="flex items-center justify-center gap-2">
      <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>Validating...</span>
    </div>
  `
  }
}